import { useLocation } from 'react-router';
import { useSidebar } from '../../hooks/useSidebar';
import {
  MenuBody,
  MenuList,
  MenuSection,
  MenuSectionIcon,
  MenuSectionLink,
  MenuSectionTitle,
  MenuSeparator,
  MenuWrapper,
} from './styles';
import { isActiveRoute } from '../../helpers/helpers';

type SidebarMenuType = {
  onNavigate: () => void;
};

export const SidebarMenu = ({ onNavigate }: SidebarMenuType) => {
  const sidebar = useSidebar();
  const { pathname } = useLocation();

  return (
    <MenuWrapper>
      <MenuBody>
        <MenuList>
          {sidebar.menu.map((menuItem) => {
            if (menuItem.separator) {
              return <MenuSeparator key='separator' />;
            }

            const { title, url, icon, paths, id } = menuItem;
            const isActiveMenuLink = isActiveRoute(pathname, paths);
            const Icon = icon;

            return (
              <MenuSection key={title} isActive={isActiveMenuLink} id={id}>
                <MenuSectionLink to={url} onClick={onNavigate}>
                  <MenuSectionIcon isActive={isActiveMenuLink}>
                    <Icon />
                  </MenuSectionIcon>
                  <MenuSectionTitle>{title}</MenuSectionTitle>
                </MenuSectionLink>
              </MenuSection>
            );
          })}
        </MenuList>
      </MenuBody>
    </MenuWrapper>
  );
};
